import React, { useEffect, useState } from "react";
import DoctorCard from "../../DoctorCard";
import { Pagination, Spin, Alert } from "antd";
import "../../../styles/doctors.scss";
import { fetchDoctors } from "../../../http/doctorAPI";

const Doctors = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const getDoctors = async () => {
      try {
        const data = await fetchDoctors();
        setDoctors(Array.isArray(data) ? data : data.doctors || []);
      } catch (err) {
        console.error("Error fetching doctors:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    getDoctors();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 3;

  const paginatedDoctors = doctors.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  if (loading) return <Spin tip="Loading doctors..." />;
  if (error) return <Alert type="error" message="Failed to load doctors" />;

  return (
    <div className="doctors-container">
      {doctors.length > 0 ? (
        <div className="doctors-section">
          {paginatedDoctors.map((doc, index) => (
            <DoctorCard key={index} doctor={doc} />
          ))}
        </div>
      ) : (
        <p>No doctors found</p>
      )}
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={doctors.length}
        onChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default Doctors;
